import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Link, useParams, useHistory } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import validationsAddPosition from "../../../validtions/forms/position/add";
import sizesBanner from "../advertise/banner/sizes-banner";
import position from "../../../messages/position";

function EditPosition() {
  const params = useParams();
  const history = useHistory();
  const [message, setMessage] = useState();

  const [pageData, setPageData] = useState({});
  const [price, setPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [alternativePrice, setAlternativePrice] = useState(0);
  const [count, setCount] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [active, setActive] = useState(false);
  const [activeAlternative, setActiveAlternative] = useState(false);
  const [maxPriority, setMaxPriority] = useState();
  const [priority, setPriority] = useState();

  const positionID = params.id;
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getPositionData(positionID);
  }, []);

  useEffect(() => {
    changePrice();
  }, [basePrice]);

  useEffect(() => {
    changePrice();
  }, [count]);

  useEffect(() => {
    if (!Object.keys(pageData).length) {
      return;
    }
    getMaxPriorityPositionOnPage();
  }, [pageData]);

  const getMaxPriorityPositionOnPage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const maxPriority = await sendRequestGetMaxPriorityPositionOnPage(
      pageData.pag_id
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!maxPriority) {
      return;
    }
    setMaxPriority(maxPriority);
  };

  const sendRequestGetMaxPriorityPositionOnPage = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/" +
          pageID +
          "/get-max-priority",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  const changePrice = () => {
    if (!(count > 0)) {
      setPrice(0);
      return;
    }
    setPrice(Math.floor(basePrice / count));
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getPositionData = async (positionID) => {
    const positionData = await sendRequestGetPositionData(positionID);
    if (!positionData) {
      return;
    }

    let size = positionData.pos_size.split("-");
    setWidth(size[0]);
    setHeight(size[1]);
    setCount(positionData.pos_count);
    setBasePrice(positionData.pos_base_price);
    setAlternativePrice(positionData.pos_alternative_price);
    setPrice(positionData.pos_price);
    setActive(positionData.pos_active);
    setActiveAlternative(positionData.pos_allow_alternative);
    setPriority(positionData.pos_priority);
    await getPageData(positionData.pos_page_id);
  };

  const sendRequestGetPositionData = async (positionID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/position/manage/" + positionID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const getPageData = async (pageID) => {
    setPageData(await sendRequestGetPageData(pageID));
  };

  const sendRequestGetPageData = async (pageID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/manage/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();

    const dataForm = getDataForm();
    if (validationsAddPosition(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validationsAddPosition(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }
    dataForm.page_id = pageData.pag_id + "";
    await editPosition(dataForm);
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".add-page");
    element.scrollIntoView();
  };

  const getDataForm = () => {
    return {
      count: document.querySelector("#count").value,
      base_price: basePrice + "",
      price: price + "",
      alternative_price: alternativePrice + "",
      height: document.querySelector("#height").value,
      width: document.querySelector("#width").value,
      allow_alternative: activeAlternative,
      active: active,
      priority: document.querySelector("#priority").value,
    };
  };

  const editPosition = async (data) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestEditPosition(data);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    history.push("/manage/position/all/" + pageData.pag_id);
  };

  const inputAlternativePriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAlternativePrice(parseInt(number));
  };

  const sendRequestEditPosition = async (data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/position/manage/" + positionID,
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  const inputPriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setBasePrice(parseInt(number));
  };

  const inputPriceBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateButtonsSize = () => {
    return sizesBanner.map((sizeBanner) => {
      return (
        <div className="col-3 py-2">
          <div
            onClick={(e) => {
              e.preventDefault();
              setWidth(sizeBanner.width);
              setHeight(sizeBanner.height);
            }}
            className="btn btn-primary letter-spacing-finance-number p-2"
          >
            {helpersNumbers.toPersianNum(sizeBanner.height)}
            {"    "}-{"    "}
            {helpersNumbers.toPersianNum(sizeBanner.width)}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span> اضافه کردن جایگاه به </span>
                  <span className="pr-2 text-info">{pageData.pag_title}</span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card" id="edit-position">
            <div className="card-body">
              {messageTag}
              {pageData !== null ? (
                <div className="text-left">
                  <Link to={`/manage/position/all/${pageData.pag_id}`}>
                    <div className="btn btn-primary">
                      <span>
                        <span className="text-white">بازگشت</span>
                      </span>
                      <span className="pr-2">
                        <i className="fas fa-arrow-left" aria-hidden="true"></i>
                      </span>
                    </div>
                  </Link>
                </div>
              ) : (
                <></>
              )}
              <form className="w-50" onSubmit={sendForm}>
                <div className="form-group">
                  <label>تعداد بنر در جایگاه</label>
                  <input
                    dir="ltr"
                    type="number"
                    id="count"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      e.preventDefault();
                      setCount(parseInt(e.target.value));
                    }}
                    value={count}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>مبلغ پایه (تومان)</label>
                  <input
                    tabIndex="2"
                    dir="ltr"
                    name="price"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(basePrice)
                    )}
                    onChange={inputPriceChangeHandler}
                    onBeforeInput={inputPriceBeforeInputHandler}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>مبلغ کل : </label>
                  <span
                    className="letter-spacing-finance-number"
                    style={{ fontSize: "22px" }}
                  >
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(price)
                    )}
                  </span>
                </div>

                <div className="form-group">
                  <label className="pl-2">فعال بودن تبلیغ جایگزین</label>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active-advertise-alternative"
                        checked={activeAlternative}
                        onChange={() => {
                          setActiveAlternative(!activeAlternative);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <label>مبلغ بنر جایگزین</label>
                  <input
                    type="text"
                    id="alternative-price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(alternativePrice)
                    )}
                    onChange={inputAlternativePriceChangeHandler}
                    onBeforeInput={inputPriceBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>

                <div className="form-group">
                  <div className="d-flex justify-content-between">
                    <div>
                      <label>ارتفاع</label>
                      <input
                        tabIndex="3"
                        dir="ltr"
                        type="number"
                        id="height"
                        defaultValue={height || ""}
                        className="form-control"
                        required
                      />
                    </div>
                    <div>
                      <label>عرض</label>
                      <input
                        tabIndex="2"
                        dir="ltr"
                        type="number"
                        id="width"
                        defaultValue={width || ""}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div className="pt-3">
                    <label>اندازه بنرهای تبلیغاتی</label>
                    <div className="row">{generateButtonsSize()}</div>
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    اولویت برای گروه نمایش دهنده خودکار (
                    {maxPriority && (
                      <span>
                        بالاترین اولویت در این صفحه =
                        {helpersNumbers.toPersianNum(maxPriority)}
                      </span>
                    )}
                    )
                  </label>
                  <input
                    tabIndex="5"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    id="priority"
                    className="form-control"
                    defaultValue={priority}
                    required
                  />
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active"
                        checked={active}
                        onChange={() => {
                          setActive(!active);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>
                <div className="form-group">
                  <button className="btn btn-primary">ویرایش کردن</button>
                </div>
                <div className="form-group">
                  <div className="border border-success">
                    <a
                      href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.pag_img_name}`}
                      target="_blank"
                    >
                      <img
                        className="img-fluid"
                        src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.pag_img_name}`}
                      />
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditPosition;
